const LOCAL_BASE_URL = "http://192.168.1.4:4500/api/v1/";
const LIVE_BASE_URL = "https://api.goodway.com.es/api/v1/";

export const BASE_URL =
  process.env.NODE_ENV === "development" ? LOCAL_BASE_URL : LIVE_BASE_URL;
export default {
  // -----AUTH------//
  getUsers: BASE_URL + "user/all",
  getUserData: BASE_URL + "user",
  signUp: BASE_URL + "/user/signup",
  signIn: BASE_URL + "/user/testLogin",
  blockUser: BASE_URL + "user/updateProfile",
  getEmployees: BASE_URL + "/employee",
  updateUser: BASE_URL + "/user",
  getFeedbacks: BASE_URL + "feedback",
  getPrivacyPolicy: BASE_URL + "/privacy",
  deletePrivacyPolicy: BASE_URL + "privacyPolicy",
  getAllFeedbacks: BASE_URL + "/feedback/getAll",
  deleteFeedback: BASE_URL + "/feedback/delete",

  getAllRoots: BASE_URL + "routes",

  createStage: BASE_URL + "stages",
  updateStage: BASE_URL + "stages",
  createRoot: BASE_URL + "routes",

  GetBusiness: BASE_URL + "allbusiness",
  createBusiness: BASE_URL + "businessDirectory",
  updateBusiness: BASE_URL + "businessDirectory",
  deleteBusiness: BASE_URL + "businessDirectory",
  createInterest: BASE_URL + "interest",
  getStages: BASE_URL + "all",
  updateInterest: BASE_URL + "interest",
  deleteStage: BASE_URL + "stages",
  updatePrivacyPolicy: BASE_URL + "/privacy",

  getAbout: BASE_URL + "aboutUs",
  updateAbout: BASE_URL + "aboutUs",
  deleteAbout: BASE_URL + "aboutUs",
  getTermsOfUse: BASE_URL + "/termsandcondition",
  addTermsOfUse: BASE_URL + "/termsandcondition/create",
  updateTermsOfUse: BASE_URL + "/termsandcondition",
  deleteTermsOfUse: BASE_URL + "/termsandcondition",

  getUserSupports: BASE_URL + "userSupport",

  getGeneres: BASE_URL + "genere",
  createGenere: BASE_URL + "genere",
  deleteGenere: BASE_URL + "genere",
  updateGenres: BASE_URL + "genere",

  addAboutUs: BASE_URL + "aboutUs",
  deleteRoot: BASE_URL + "routes",
  updateRoot: BASE_URL + "routes",

  getContactUs: BASE_URL + "contact",
  createContactUs: BASE_URL + "contact",
  deleteContactUs: BASE_URL + "contact",
  updateContactUs: BASE_URL + "contact",
  logOut: BASE_URL + "user/logout",
  updateEmployee: BASE_URL + "/employee/approveEmp",

  // -----------Products--------------//

  getProducts: BASE_URL + "/product/getAll?limit=1000",
  upDateProduct: BASE_URL + "/product/update",
  createProduct: BASE_URL + "/product/create",
  deleteProduct: BASE_URL + "/product/delete",
  allBookedProduct: BASE_URL + "/booking/allbookedproducts",
  // -------------Services-------------//

  getAllServices: BASE_URL + "/service/getall",
  createService: BASE_URL + "/service/create",
  deleteService: BASE_URL + "/service/delete",
  updateService: BASE_URL + "/service/update",
  allBookedServices: BASE_URL + "/booking/allbookedservices",

  // -------------Services-------------//
};
